import CryptoJS from 'crypto-js';

export const SecretKey = "ThisIsASecretKey"

export const set = (keys, value) => {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value?.toString()), key,
        {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

    return encrypted?.toString();
}

// //The get method is use for decrypt the value.
// export const get = (keys, value) => {
//     var key = CryptoJS.enc.Utf8.parse(keys);
//     var iv = CryptoJS.enc.Utf8.parse(keys);
//     var decrypted = CryptoJS.AES.decrypt(value || {}, key, {
//         keySize: 128 / 8,
//         iv: iv,
//         mode: CryptoJS.mode.CBC,
//         padding: CryptoJS.pad.Pkcs7
//     });

//     return decrypted?.toString(CryptoJS.enc.Utf8);
// }


export const decryptToken = (encryptedToken) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(SecretKey);

        // Handle arrays of encrypted strings
        if (Array.isArray(encryptedToken)) {
            return encryptedToken.map(token => {
                const bytes = CryptoJS.AES.decrypt(token, key, {
                    keySize: 128 / 8,
                    mode: CryptoJS.mode.ECB, // Use ECB mode since you don't have an IV
                    padding: CryptoJS.pad.Pkcs7
                });
                return bytes.toString(CryptoJS.enc.Utf8);
            });
        }

        // Handle single encrypted string
        const bytes = CryptoJS.AES.decrypt(encryptedToken, key, {
            keySize: 128 / 8,
            mode: CryptoJS.mode.ECB, // Use ECB mode since you don't have an IV
            padding: CryptoJS.pad.Pkcs7
        });

        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        return originalText;
    } catch (error) {
        console.error('Error decrypting token:', error);
        return null;
    }
};
